import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
  signal,
  inject,
} from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { MatDialog } from '@angular/material/dialog'
import {
  IRouteSelectDialogMultiOptions,
  ScheduleSelectDialogMultiComponent,
} from '../../../work-items/schedule-select-dialog-multi/schedule-select-dialog-multi.component'
import {
  IWorkOrderDetailDialogOptions,
  WorkOrderDialogComponent,
} from '../../../work-orders/work-order-dialog/work-order-dialog.component'
import { ConstraintInput } from '../../../../shopfloor/workcenters/capability/constraints/constraintInput'
import { Instant } from '@js-joda/core'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { AsyncPipe } from '@angular/common'
import { WorkItemUtilisationTableComponent } from '../../work-items/work-item-table/work-item-utilisation-table.component'
import { MatButton } from '@angular/material/button'
import {
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneTitleComponent,
  ElderPaneActionsComponent,
  ElderPaneSubtitleComponent,
} from '@elderbyte/ngx-starter'

@Component({
  selector: 'app-work-center-order-detail',
  templateUrl: './work-center-order-detail.component.html',
  styleUrls: ['./work-center-order-detail.component.scss'],
  imports: [
    MatButton,
    WorkItemUtilisationTableComponent,
    AsyncPipe,
    ElderTranslatePipe,
    ElderPaneComponent,
    ElderPaneContentComponent,
    ElderPaneTitleComponent,
    ElderPaneSubtitleComponent,
    ElderPaneHeaderComponent,
    ElderPaneActionsComponent,
  ],
})
export class WorkCenterOrderDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly workCenterId = input.required<string>()
  public readonly workOrderId = input.required<string>()
  public readonly itemConstraints = input<ConstraintInput[]>([])
  public readonly canChangeRoutes = signal<boolean>(false)
  private matDialog = inject(MatDialog)

  @Output()
  public readonly contextRefreshRequest: EventEmitter<Instant> = new EventEmitter()

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public choseProductionRoutes(): void {
    if (this.workOrderId && this.workCenterId) {
      this.matDialog
        .open(ScheduleSelectDialogMultiComponent, {
          minWidth: '90vw',
          height: '90vh',
          data: <IRouteSelectDialogMultiOptions>{
            workOrderId: this.workOrderId(),
            workCenterId: this.workCenterId(),
            itemConstraints: this.itemConstraints(),
          },
        })
        .afterClosed()
        .subscribe((_) => this.contextRefreshRequest.emit(Instant.now()))
    }
  }

  public goToWorkOrder(): void {
    if (this.workOrderId) {
      this.matDialog.open(WorkOrderDialogComponent, {
        minWidth: '95vw',
        height: '95vh',
        data: <IWorkOrderDetailDialogOptions>{
          orderId: this.workOrderId(),
        },
      })
    }
  }
}
